import { debounceTime } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import {
  selectImmunizationsInStore,
  selectImmunizationsPageLoading,
  selectImmunizationsWaitingMessage,
} from '../_selectors/immunization.selectors';
import { Immunization } from '../_models/immunization.model';

export class ImmunizationsDataSource extends BaseDataSource {
  private allItems: Immunization[];

  constructor(private store: Store<AppState>, private paginator) {
    super();

    this.store
      .pipe(select(selectImmunizationsInStore), debounceTime(600))
      .subscribe((response: QueryResultsModel) => {
        this.allItems = response.items;
        this.allItems.sort((a, b) => {
          return new Date(a.recordedDate).getTime() < new Date(b.recordedDate).getTime() ? 1 : -1;
        });
        this.entitySubject.next(response.items.slice(0, this.paginator.pageSize));
        this.paginatorTotalSubject.next(response.totalCount);
      });

    this.isPreloadTextViewed$ = this.store.pipe(select(selectImmunizationsWaitingMessage));

    this.loading$ = this.store.pipe(select(selectImmunizationsPageLoading));
  }

  getAllItems() {
    return this.allItems;
  }

  setAllItems(items) {
    this.allItems = items;
  }
}
